import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.pages.Identification.title',
    defaultMessage: 'Identification',
  },
  subtitle: {
    id: 'app.pages.Identification.subtitle',
    defaultMessage: 'For security reasons, we need to verify your identity. Please enter the details below to continue to your claim.',
  },
  formPlateNumber: {
    id: 'app.pages.Identification.form.plateNumber',
    defaultMessage: 'Plate number',
  },
  formPhoneNumber: {
    id: 'app.pages.Identification.form.phoneNumber',
    defaultMessage: 'Phone number',
  },
  continue: {
    id: 'app.pages.Identification.continue',
    defaultMessage: 'Continue',
  },
  verificationIssueTitle: {
    id: 'app.pages.Identification.verification.title',
    defaultMessage: 'Verification issue',
  },
  verificationIssueText: {
    id: 'app.pages.Identification.verification.text',
    defaultMessage: "We couldn't verify your information. Please review the details and try again.",
  },
  verificationCheck: {
    id: 'app.pages.Identification.verification.check',
    defaultMessage: 'Check information',
  },
});
